import http from '@/utils/http'

export default {
  // 律师前三名展示数据请求接口
  getPositionLawyerList (params) {
    return http.get('/promotion/v1/api/lawyer/reviewLawyerList?pageIndex=' + params.pageIndex +
      '&pageSize=' + params.pageSize + '&city=' + params.city)
  }
}



// WEBPACK FOOTER //
// ./src/components/home/api/index.js